import React, { useContext, useState, useEffect, useCallback } from 'react';
import { auth } from '../firebase';
import { useCookies } from 'react-cookie';
import { useQueryClient } from '@tanstack/react-query';

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);
  const [, , removeCookie] = useCookies(['authToken']);
  const queryClient = useQueryClient();

  const logout = useCallback(async () => {
    try {
      await auth.signOut();
      localStorage.clear();
      sessionStorage.clear();
      removeCookie('authToken', { path: '/' });
      queryClient.clear();
      setCurrentUser(null);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  }, [removeCookie, queryClient]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          await user.getIdToken(true);
          setCurrentUser(user);
        } catch (error) {
          console.error('Token expired or invalid:', error);
          await logout();
        }
      } else {
        removeCookie('authToken', { path: '/' });
        setCurrentUser(null);
        localStorage.clear();
        queryClient.clear();
      }
      setLoading(false);
    });

    const tokenInterval = setInterval(
      async () => {
        if (auth.currentUser) {
          try {
            await auth.currentUser.getIdToken(true);
          } catch (error) {
            console.error('Token refresh failed:', error);
            await logout();
          }
        }
      },
      1000 * 60 * 5
    );

    return () => {
      unsubscribe();
      clearInterval(tokenInterval);
    };
  }, [logout, removeCookie]);

  // const checkEmailVerified = () => {
  //   return currentUser?.emailVerified || false;
  // };

  const value = {
    currentUser,
    logout,
    // checkEmailVerified,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
